import { DirectiveOptions } from 'vue';
import { AccountModule } from '@/store/modules/account';

export const permission: DirectiveOptions = {
  inserted(el, binding) {
    const { value } = binding;
    const permissionNames = AccountModule.permissions.map((item) => item.name);
    if (value && value instanceof Array && value.length > 0) {
      const permissionValue = value;
      const hasPermission = permissionNames.some((name) => {
        return permissionValue.includes(name);
      });
      if (!hasPermission) {
        const parentNode = el.parentNode;
        parentNode?.removeChild(el);
      }
    } else {
      throw new Error('need roles! Like v-permission="[\'Todo_Create\',\'Requirement_Adopt\']"');
    }
  },
};
